const multiInstanceScreens = ['salesorder', 'shiptoopportunities','purchaseorder','pricematriximport']
export default route => multiInstanceScreens.includes(route)